/**
 * Header the Core API branches on. The "canary" name is a leftover from the
 * New Shop rollout; Core still requires it, so the name and the value stay
 * pinned on the wire even though the rollout itself is long finished.
 */
export const CORE_SHOP_HEADER = 'bl-shop-canary';
export const CORE_SHOP_HEADER_VALUE = 'enabled';

export const TOKEN_KEY = 'token';
export const USER_KEY = 'user';
export const CUSTOMER_DATA_CONFIRMED = 'customerDataConfirmed';
export const ADBANNERS_HIDDEN_KEY = 'adbannersHidden';
export const SURVEY_SHOWN_KEY_PREFIX = 'surveyShown_';
export const BRINGLIESEL_MAIN_PAGE_URL = 'https://www.bringliesel.de/';
export const BRINGLIESEL_HELP_URL = 'https://hilfe.bringliesel.de/';
export const BRINGLIESEL_CONTACT_URL = 'https://www.bringliesel.de/#kontakt';
export const BRINGLIESEL_IMPRESSUM_URL =
  'https://www.bringliesel.de/impressum/';
export const BRINGLIESEL_AGB_URL = 'https://www.bringliesel.de/agb';
export const BRINGLIESEL_PRIVACY_POLICY_URL =
  'https://www.bringliesel.de/datenschutz';
export const BRINGLIESEL_DATA_PROTECTION_URL =
  'https://www.bringliesel.de/datenschutzinformation';

export const CIRCULAR_TEMPLATE_LINK =
  'https://cdn.bringliesel.de/pdfs/docs/BringLiesel_Vorlage_Rundschreiben.docx';
export const INFORMATION_SHEET_LINK =
  'https://cdn.bringliesel.de/pdfs/docs/BringLiesel_Informationsblatt.pdf';
export const BRINGLIESEL_BROCHURE_LINK =
  'https://assets.bringliesel.de/pdfs/BringLiesel_Broschuere.pdf';
export const BRINGLIESEL_POSTER_LINK =
  'https://cdn.bringliesel.de/pdfs/docs/BringLiesel_Poster_A4.pdf';
export const DATA_PROTECION_NOTE_LINK =
  'https://cdn.bringliesel.de/pdfs/docs/Datenschutzhinweise_BringLiesel.pdf';
export const PRODUCT_CATALOG_LINK = 'https://bringliesel.de/pdf/katalog.pdf';
export const XMAS_BROSCHURE_LINK =
  'https://bringliesel.de/pdf/Weihnachtsangebot-BringLiesel_2026.pdf';
export const XMAS_PAGE_LINK = 'https://xmas.bringliesel.de/#/';
export const XMAS_POPUP_LINK =
  'https://xmas.bringliesel.de/?utm_source=shop&utm_medium=popup';
export const XMAS_LOGIN_CTA_LINK =
  'https://xmas.bringliesel.de/?utm_source=shop&utm_medium=login-page';
export const XMAS_LOGIN_CARD_LINK =
  'https://xmas.bringliesel.de/?utm_source=shop&utm_medium=login-card';

export const LOGIN_ATTEMPTS_LIMIT = 5;
export const NOTE_CHARACTER_LIMIT = 100;
